import { PaginationChangedEvent } from 'ag-grid-community';
import { useCallback, useEffect, useState } from 'react';

import { ArrayUtils } from '@/utils/array.utils';


export function useClientSidePagination(
  rows: unknown[], 
  pageSize: number, 
  groupedColumn: string | undefined = undefined) {

  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    const rowsCount = groupedColumn ? ArrayUtils.getGroupedRowsCount(rows, groupedColumn) : rows.length;
    setTotalPages(Math.ceil(rowsCount / pageSize));
  }, [pageSize, rows, groupedColumn]);

  const onPaginationChanged = useCallback((event: PaginationChangedEvent) => {
    if (event.newPage) {
      setCurrentPage(event.api.paginationGetCurrentPage());
    }
  }, []);


  return { currentPage, setCurrentPage, totalPages, setTotalPages, onPaginationChanged };
}
